export default "__VITE_ASSET__B6bDq1YY__"